<ds-register-email-form
        [MESSAGE_PREFIX]="'register-page.registration'">
</ds-register-email-form>
